import React, { useRef } from "react";

const ContentProductVideoAi = () => {
  const data = [
    {
      title: "PRODUCT VIDEO",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1080-product-video.mp4"],
      level: "",
    },
    {
      title: "PRODUCT VIDEO",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1080-product-video2.mp4"],
      level: "",
    },
    {
      title: "PRODUCT VIDEO",
      link: ["https://backend.whalesai.com/public/hiwvideos/1080-1080-product-video3.mp4"],
      level: "",
    },
  ];

  const videoRefs = useRef([]);

  const handlePlay = (index) => {
    videoRefs.current.forEach((video, i) => {
      if (i !== index && video) {
        video.pause();
      }
    });
  };

  return (
    <div className="text-white">
      <div>
        {data.map((video, index) => (
          <div key={index} className="text-center">
            {video.level && <p>{video.level}</p>}
            {video.link.map((i, j) => (
              <div
                key={j}
                style={{ marginBlock: "20px" }}
                className="d-flex gap-2 flex-column justify-content-center align-items-center mx-auto"
              >
                <video
                  controls
                  playsInline
                  src={i}
                  className="comic-video"
                  type="video/mp4"
                  ref={(el) => (videoRefs.current[index] = el)}
                  onPlay={() => handlePlay(index)}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentProductVideoAi;